module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/quantum-phone-video-mobile.7bba16c1.mp4";